import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchInfiniteCategoriesArgs,
  FetchCategoryByKeyArgs,
  FetchCategoryByIdArgs,
  FetchCategoriesArgs,
} from '../api/types/categories.types';

import {
  fetchPublicCategories,
  fetchCategoryByKey,
  fetchCategoryById,
  fetchCategories,
} from '../api/categories.api';

export const categoriesQueryKeys = createQueryKeys('categories', {
  fetchCategories: ({
    appliesTo,
    filters,
    organizationId,
    organizationIds,
    withPlatform,
  }: FetchCategoriesArgs) => ({
    queryFn: () =>
      fetchCategories({
        appliesTo,
        filters,
        organizationId,
        organizationIds,
        withPlatform,
      }),
    queryKey: [
      organizationId,
      filters,
      withPlatform,
      appliesTo,
      organizationIds,
    ],
  }),
  fetchCategoryById: ({ id, organizationId }: FetchCategoryByIdArgs) => ({
    queryFn: () => fetchCategoryById({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchCategoryByKey: ({ key }: FetchCategoryByKeyArgs) => ({
    queryFn: () => fetchCategoryByKey({ key }),
    queryKey: [key],
  }),
  fetchInfiniteCategories: ({
    appliesTo,
    filters,
    organizationId,
    withPlatform = true,
  }: FetchInfiniteCategoriesArgs) => ({
    queryFn: (context) =>
      fetchCategories({
        appliesTo,
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        organizationId,
        withPlatform,
      }),
    queryKey: [organizationId, filters, withPlatform, appliesTo],
  }),
  fetchInfinitePublicCategories: ({
    filters,
  }: Omit<
    FetchInfiniteCategoriesArgs,
    'appliesTo' | 'organizationId' | 'withPlatform'
  >) => ({
    queryFn: (context) =>
      fetchPublicCategories({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
      }),
    queryKey: [filters],
  }),
});
